.bs{position:absolute;}